import React from 'react';

// Small informational modal for the `alreadyOnboarded` branch of
// createStripeConnectAccount. Two situations land here:
//
//   1. reconnected: the backend found an existing Stripe Connect account for
//      this EMAIL (typically from a deleted-and-recreated account) and linked
//      it to this user. Without this modal the user taps "Set up payout",
//      watches a long spinner, and is silently advanced with no explanation
//      of why Stripe onboarding never appeared (found during Android testing,
//      2026-08-20).
//   2. plain already-onboarded: our Firestore flag was stale; Stripe says
//      setup is complete.
//
// Confirm pages navigate to settlement on dismiss (pass the navigation in
// `onClose`); settlement/Profile pages just close it.
const PayoutAccountLinkedModal = ({ isOpen, reconnected, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px'
      }}
    >
      <div style={{
        backgroundColor: '#fff', borderRadius: '16px', padding: '24px',
        maxWidth: '380px', width: '100%', textAlign: 'center',
        fontFamily: 'Nunito, sans-serif', boxSizing: 'border-box'
      }}>
        <div style={{
          width: '48px', height: '48px', borderRadius: '50%', margin: '0 auto 12px',
          backgroundColor: '#d4edda', color: '#155724',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px'
        }}>✓</div>
        <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#1f2937' }}>
          Payout account ready
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#4b5563', lineHeight: 1.5 }}>
          {reconnected
            ? 'An existing Stripe payout account for your email address was found and linked to your account. No further setup is needed.'
            : 'Your payout account is already set up. No further setup is needed.'}
        </p>
        <button
          type="button"
          onClick={onClose}
          style={{
            backgroundColor: '#C9A227', color: '#fff', border: 'none',
            borderRadius: '25px', padding: '10px 32px', fontSize: '15px',
            fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit'
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default PayoutAccountLinkedModal;
